module.exports = __webpack_public_path__ + "img/check.e12e1b97.svg";